import { useMemo } from "react";

import { generateBranchUrl } from "utils/urls";
import TableCellProjectRoot from "ds/components/Table/Row/CellProjectRoot";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { StackSuggestions } from "constants/stack";

import useCellFilterAction from "../useCellFilterAction";

const StacksTableProjectRootCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const isEmpty = !stack.apiHost || !stack.projectRoot;

  const projectRootFilterAction = useCellFilterAction({
    filterName: StackSuggestions.ProjectRoot,
    filterValue: stack.projectRoot || "",
  });

  const actions = useMemo(
    () => (isEmpty ? undefined : [projectRootFilterAction]),
    [isEmpty, projectRootFilterAction]
  );

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {stack.apiHost && stack.projectRoot && (
        <TableCellProjectRoot
          href={generateBranchUrl({
            apiHost: stack.apiHost,
            branch: stack.branch,
            namespace: stack.namespace,
            repository: stack.repository,
            repositoryURL: stack.repositoryURL || "",
            provider: stack.provider,
            projectRoot: stack.projectRoot,
          })}
        >
          {stack.projectRoot}
        </TableCellProjectRoot>
      )}
    </TableSimpleCell>
  );
};

export default StacksTableProjectRootCell;
